var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontalPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.531,
    height: 24.105,
    viewBox: "0 0 18.531 24.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_23_move2_px24",
    transform: "translate(0.225 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(-2715.278 -1541.726)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M2732.918,1646.639h-1.05v-.574a1.335,1.335,0,0,0,0-2.547v-.47h1.05a.453.453,0,0,0,0-.906h-2.981a.453.453,0,0,0,0,.906h1.05v.42h-13.339v-.42h1.05a.453.453,0,0,0,0-.906h-2.981a.453.453,0,0,0,0,.906h1.05v.47a1.335,1.335,0,0,0,0,2.547v.574h-1.05a.453.453,0,0,0,0,.906h2.981a.453.453,0,0,0,0-.906h-1.05v-.524h4.12v4.838c0,.053,0,.107-.008.161h0l-.894,9.23h0a1.527,1.527,0,0,0,.322,1.1,1.442,1.442,0,0,0,.986.547c.05.005.1.008.151.008a1.428,1.428,0,0,0,.922-.339,1.51,1.51,0,0,0,.531-1.015h0l.543-5.531.562,5.533h0a1.482,1.482,0,0,0,1.454,1.352c.049,0,.1,0,.149-.008a1.5,1.5,0,0,0,1.308-1.649h0l-.894-9.23h0c-.005-.053-.008-.107-.008-.161v-4.838h4.1v.524h-1.05a.453.453,0,0,0,0,.906h2.981a.453.453,0,0,0,0-.906Zm-6.521,14.454a.589.589,0,0,1-.639-.536h0l-.815-8.031a.043.043,0,0,0,0-.01.628.628,0,0,0-1.251.011h0l-.79,8.031a.588.588,0,0,1-.638.536.574.574,0,0,1-.392-.218.609.609,0,0,1-.128-.44h0l.894-9.23h0c.008-.083.012-.167.012-.25v-4.888h0a.845.845,0,0,0-.831-.856h-4.7a.418.418,0,0,1,0-.836h14.4a.418.418,0,0,1,0,.836h-4.673a.845.845,0,0,0-.831.856v4.888c0,.084,0,.169.012.252h0l.894,9.229h0A.6.6,0,0,1,2726.4,1661.093Z",
    transform: "translate(0 -96.547)",
    strokeWidth: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M5578.779,1565.532a2.357,2.357,0,1,0-2.357-2.356A2.359,2.359,0,0,0,5578.779,1565.532Zm0-3.666a1.31,1.31,0,1,1-1.311,1.31A1.311,1.311,0,0,1,5578.779,1561.866Z",
    transform: "translate(-5569.739 -1560.819)",
    strokeWidth: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontalPlane);
export default __webpack_public_path__ + "static/media/FrontalPlane.c8e5f9f1cd25515260ec5b519c68b353.svg";
export { ForwardRef as ReactComponent };